/* eslint-disable no-param-reassign */
import { getCarrierLogoImagePath } from '@/components/modules/carrier/logo';
import { space } from '@/theme/constants/space';
import { SegmentModeType } from '@/types/api-types';
import { tv } from '@/utils/styles';

export interface CarrierLogoProps {
  carrierCode: string;
  mode?: SegmentModeType;
  hasMargin?: boolean;
  size?: string | number;
  className?: string;
}

const CarrierLogo = ({ carrierCode = '', mode = 'air', size = 'md', className, ...props }: CarrierLogoProps) => {
  const path = getCarrierLogoImagePath(mode, carrierCode);

  const sizeValue = size ? space[size] || size : null;

  const { base, image } = styles();

  return (
    <span className={base({ className })} {...props}>
      {/* Can't use next/image without a px width and height */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={path}
        alt={`Carrier Identifier: ${carrierCode}`}
        width={sizeValue as string}
        height={sizeValue as string}
        loading="lazy"
        className={image()}
        style={{ width: sizeValue as string, height: sizeValue as string }}
      />
    </span>
  );
};

const styles = tv({
  slots: {
    base: `block shrink-0 overflow-hidden rounded-sm`,
    image: `block h-auto w-full`,
  },
});

export { CarrierLogo };
